// extracted by mini-css-extract-plugin
export default {"logo":"promoted-sponsorship_logo__rX6g-","small_logo":"promoted-sponsorship_small_logo__Glh6A"};